import { render, staticRenderFns } from "./VrsteSuorganizatora.vue?vue&type=template&id=05ddf8f1&scoped=true&"
import script from "./VrsteSuorganizatora.vue?vue&type=script&lang=js&"
export * from "./VrsteSuorganizatora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ddf8f1",
  null
  
)

export default component.exports